module.exports = __webpack_public_path__ + "img/addButton.83f6e64e.svg";